import { ResultStatus } from '../../../../core/picks/pick-models';
import { BetslipError, CleanStrategy, ErrorOrigin } from '../betslip-error';
import { NotifyUserErrorMixin } from '../notify-user-error';
import { ResultError } from '../result/result-error';

export class ResultStateChanged extends NotifyUserErrorMixin<ResultError>(ResultError) {
    constructor(
        pickId: string,
        public previousResult: ResultStatus,
        public currentResult: ResultStatus,
    ) {
        super(pickId);
        this.origin = ErrorOrigin.BetSlip;
        this.cleanStrategy = CleanStrategy.Manually;
        this.hasClientValidation = false;
        this.isHidden = true;
    }

    override equals(error: BetslipError): boolean {
        return (
            error instanceof ResultStateChanged &&
            error.pickId === this.pickId &&
            error.previousResult === this.previousResult &&
            error.currentResult === this.currentResult
        );
    }
}
